export { default as MentionTypeaheadOption } from './MentionTypeaheadOption';
